import { getCurrentInstance, onMounted, onUnmounted } from 'vue';

export function useSocketConnection({ channel, event, callback }) {
    const instance = getCurrentInstance();

    if (!instance) {
        throw new Error(
            'getCurrentInstance() returned null. Make sure you are properly calling this function in setup() or created()'
        );
    }

    const { $echo } = instance.appContext.config.globalProperties;

    if (!$echo) {
        throw new Error('Echo instance is not found. Please check if echo is properly installed.');
    }

    let echoChannel = null;

    const setupEchoListener = () => {
        if (echoChannel) return;

        echoChannel = $echo.private(channel).listen(event, async payload => {
            if (typeof callback === 'function') {
                await callback(payload);
            }
        });
    };

    const removeEchoListener = () => {
        if (echoChannel) {
            echoChannel.stopListening(event);

            echoChannel = null;
        }
    };

    onMounted(() => {
        setupEchoListener();
    });

    onUnmounted(() => {
        removeEchoListener();
    });
}
